<template>
  <span>
    <v-row dense v-for="chart in chartDataComputed" :key="chart.chartRef">
      <v-col>
        <v-card-charts-dashboard
          :title="chart.title"
          :options="chart.options"
          :deep-copy-on-update="chart.deepCopyOnUpdate"
          :is-loading="chart.loading"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script>
export default {
  name: "DashboardServicosVisaoMunicipiosCardsKpisPorMunicipio",
  components: {
    VCardChartsDashboard: () =>
      import("@/components/base/VCardChartsDashboard.vue"),
  },
  props: {
    dados: {
      type: Array,
      required: true,
    },
    municipios: {
      type: Array,
      required: true,
    },
    metasKpis: {
      type: Object,
      required: true,
    },
    tipoOrdenacao: {
      type: String,
      required: true,
    },
    kpiOrdenacao: {
      type: String,
      required: true,
    },
    exportingOptions: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    chartPendentesOptions: {},
    chartPsaOptions: {},
    chartPatOptions: {},
    chartCompensacoesOptions: {},
    chartData: [
      {
        title: "Serviços Pendentes",
        chartRef: "pendentes",
        optionsProp: "chartPendentesOptions",
        deepCopyOnUpdate: false,
      },
      {
        title: "PSA - Percentual de Serviços em Atraso",
        chartRef: "psa",
        optionsProp: "chartPsaOptions",
        deepCopyOnUpdate: false,
      },
      {
        title: "PAT - Prazo Médio de Atraso",
        chartRef: "pat",
        optionsProp: "chartPatOptions",
        deepCopyOnUpdate: false,
      },
      {
        title: "Compensações",
        chartRef: "compensacoes",
        optionsProp: "chartCompensacoesOptions",
        deepCopyOnUpdate: false,
      },
    ],
  }),
  computed: {
    chartDataComputed() {
      return this.chartData.map((chart) => {
        return {
          ...chart,
          options: this[chart.optionsProp],
          loading: this.loading,
        };
      });
    },
    categories() {
      const sortedValues =
        this.tipoOrdenacao === "asc"
          ? this.dados.sort(
              (a, b) =>
                Number(a[this.kpiOrdenacao] ?? 0) -
                Number(b[this.kpiOrdenacao] ?? 0),
            )
          : this.dados.sort(
              (a, b) =>
                Number(b[this.kpiOrdenacao] ?? 0) -
                Number(a[this.kpiOrdenacao] ?? 0),
            );

      return sortedValues.map((el) => el.nome_municipio);
    },
  },
  mounted() {
    this.setChartsOptions();
  },
  methods: {
    setChartsOptions() {
      this.setChartPendentesOptions();
      this.setChartPsaOptions();
      this.setChartPatOptions();
      this.setChartCompensacoesOptions();
    },
    getColumnChartDefaultOptions(categories = this.categories) {
      return {
        chart: {
          type: "column",
          height: 400,
          zoomType: "x",
          animation: false,
        },
        credits: { enabled: false },
        title: { text: null },
        subtitle: { text: null },
        legend: { enabled: false },
        xAxis: {
          categories: categories,
          crosshair: true,
          title: {
            text: "Município",
          },
        },
        yAxis: {
          title: { text: null },
        },
        lang: {
          noData: "Sem dados para exibição",
        },
        series: [],
        exporting: this.exportingOptions,
      };
    },
    setChartPendentesOptions() {
      let options = this.getColumnChartDefaultOptions();

      options.series = [
        {
          name: "Pendentes",
          animation: false,
          data: this.dados.map((dados) => {
            return {
              x: this.municipios.indexOf(dados.nome_municipio),
              y: Number(dados.pendentes),
              color:
                Number(dados.pendentes) >
                Number(this.metasKpis?.[dados.codigo_ibge]?.pendentes)
                  ? "#FF5252"
                  : this.$vuetify.theme.themes.light.primary,
            };
          }),
        },
      ];

      this.chartPendentesOptions = options;
    },
    setChartPsaOptions() {
      let options = this.getColumnChartDefaultOptions();

      options.yAxis.max = 100;

      options.series = [
        {
          name: "PSA",
          animation: false,
          data: this.dados.map((dados) => {
            return {
              x: this.municipios.indexOf(dados.nome_municipio),
              y: Number(dados.psa),
              color:
                Number(dados.psa) >
                Number(this.metasKpis?.[dados.codigo_ibge]?.psa)
                  ? "#FF5252"
                  : this.$vuetify.theme.themes.light.primary,
            };
          }),
        },
      ];

      this.chartPsaOptions = options;
    },
    setChartPatOptions() {
      let options = this.getColumnChartDefaultOptions();

      options.series = [
        {
          name: "PAT",
          animation: false,
          data: this.dados.map((dados) => {
            return {
              x: this.municipios.indexOf(dados.nome_municipio),
              y: Number(dados.pat),
              color:
                Number(dados.pat) >
                Number(this.metasKpis?.[dados.codigo_ibge]?.pat)
                  ? "#FF5252"
                  : this.$vuetify.theme.themes.light.primary,
            };
          }),
        },
      ];

      this.chartPatOptions = options;
    },
    setChartCompensacoesOptions() {
      let options = this.getColumnChartDefaultOptions();

      options.series = [
        {
          name: "Compensações",
          animation: false,
          data: this.dados.map((dados) => {
            return {
              x: this.municipios.indexOf(dados.nome_municipio),
              y: Number(dados.compensacoes),
              color:
                Number(dados.compensacoes) >
                Number(this.metasKpis?.[dados.codigo_ibge]?.compensacoes)
                  ? "#FF5252"
                  : this.$vuetify.theme.themes.light.primary,
            };
          }),
        },
      ];

      this.chartCompensacoesOptions = options;
    },
  },
  watch: {
    dados() {
      this.setChartsOptions();
    },
    categories() {
      this.setChartsOptions();
    },
  },
};
</script>

<style></style>
